import { KeyFeatures } from "@/components/Product/KeyFeatures/keyFeatures.component";

import { useProductPageContext } from "../../context/productPage.context";

const ProductPageKeyFeaturesContainer = () => {
    const { features } = useProductPageContext();

    return <KeyFeatures features={features} />;
};

export { ProductPageKeyFeaturesContainer };
